import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"

export class AdminFindPageContentDto {
  searchText?: string
  type?: string
}

export class AdminPageContentDto extends BaseDto {
  title: string
  titleKh: string
  content: string
  contentKh: string
  mobileContent: string
  mobileContentKh: string
  sortOrder: number
  enabled: boolean
  items: AdminPageContentItemDto[]
}

export class AdminUpdatePageContentDto {
  title?: string
  titleKh?: string
  content?: string
  contentKh?: string
  mobileContent?: string
  mobileContentKh?: string
  enabled?: boolean
}

export class AdminPageContentItemDto extends BaseDto {
  title: string
  titleKh: string
  icon: FileDto
  enabled: boolean
  sortOrder: number
  elements: AdminPageContentElementDto[]
}

export class AdminUpdatePageContentItemDto {
  title?: string
  titleKh?: string
  iconId?: string
  enabled?: boolean
}

export class AdminUpdatePageContentElementDto {
  iconId?: string
  key?: string
  keyKh?: string
  value?: string
  valueKh?: string
  enabled?: boolean
}

export class AdminPageContentElementDto extends BaseDto {
  icon: FileDto
  key: string
  keyKh: string
  value: string
  valueKh: string
  enabled: boolean
}